import LogoMakerGuest from '@fiverr-private/sidebar/entries/LogoMakerGuest';

export default LogoMakerGuest;
